import React from 'react';
import _ from 'underscore';

import {FromServerProtocol} from 'notebook/ELNConstants';
import {Selector} from 'notebook/ELNConstants';
import {BaseStep, ProtocolViewerStep, StepLevel} from 'notebook/protocols/StepConstants';
import ProtocolProcedure from 'notebook/protocols/viewer/ProtocolProcedure';
import {FullTableMap} from 'notebook/tables/excess/Evaluator';
interface ProtocolProcedureContainerProps {
  selectors: Array<Selector>;
  steps: Array<ProtocolViewerStep>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentBus: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentReplies: Array<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  comments: Array<any>;
  showFormulaBox: boolean;
  protocol: FromServerProtocol;
}

export default class ProtocolProcedureContainer extends React.Component<ProtocolProcedureContainerProps> {
  makeFullTableMap = (props: ProtocolProcedureContainerProps): FullTableMap => {
    const tableSteps = _.where(this.spreadsheetRoot(props), {level: StepLevel.TABLE});
    const tableMap: FullTableMap = {};
    for (const step of Array.from(tableSteps)) {
      tableMap[step.table!.name] = step.table!;
    }
    return tableMap;
  };

  spreadsheetRoot = (props: ProtocolProcedureContainerProps): Array<BaseStep<{id: number; cid?: string}>> =>
    props.steps;

  selectorsFromProps = (props: ProtocolProcedureContainerProps): Array<Selector> => props.selectors;

  getNoteRuntimeSnapshot = (): null => /* TODO(BNCH-14712) */ null;

  render(): JSX.Element {
    return (
      <ProtocolProcedure
        {...this.props}
        makeFullTableMap={this.makeFullTableMap}
        selectorsFromProps={this.selectorsFromProps}
        spreadsheetRoot={this.spreadsheetRoot}
        getNoteRuntimeSnapshot={this.getNoteRuntimeSnapshot}
        protocolId={this.props.protocol.id}
        versionId={this.props.protocol.versionId}
      />
    );
  }
}
